// angular imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//svg-icon imports
import { provideSvgIcons, SvgIconComponent } from '@ngneat/svg-icon';

// local imports
import { SharedModule } from '@shared/shared.module';

import { AppCommonComponents } from './components';
import { CommonIcons } from './common-icons';

@NgModule({
  declarations: [...AppCommonComponents],
  exports: [
          ...AppCommonComponents,
          SvgIconComponent,
    ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SvgIconComponent,
    SharedModule
  ],
  providers: [provideSvgIcons([...CommonIcons])],
})
export class AppCommonModule { }
